var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6664 13.6909L12.6666 11.7272V7.72728C12.6666 7.32509 12.2941 7 11.8333 7C11.3725 7 11 7.32509 11 7.72728V12.0909C11 12.32 11.1233 12.536 11.3333 12.6727L14.6664 14.8545C14.8102 14.9491 14.9854 15.0002 15.1655 15C15.4197 15 15.6696 14.9004 15.833 14.7084C16.1097 14.3876 16.0347 13.9316 15.6664 13.6909Z",
    fill: "#ED5722"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 1C5.93423 1 1 5.93423 1 12C1 18.0658 5.93423 23 12 23C18.0658 23 23 18.0658 23 12C23 5.93423 18.0658 1 12 1ZM12 21.2959C6.8749 21.2959 2.7041 17.1251 2.7041 12C2.7041 6.8749 6.8749 2.7041 12 2.7041C17.126 2.7041 21.2959 6.8749 21.2959 12C21.2959 17.1251 17.1251 21.2959 12 21.2959Z",
    fill: "#ED5722"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeIcon);
export default __webpack_public_path__ + "static/media/time-icon.94a41a459df023955619715058881153.svg";
export { ForwardRef as ReactComponent };